import { a as je, g as Me } from "./_commonjsHelpers-DjF3Plf2.js";
import Ue from "react";
import Ie from "react-is";
var te = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var se, ge;
function $e() {
  if (ge) return se;
  ge = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var a = {}, b = 0; b < 10; b++)
        a["_" + String.fromCharCode(b)] = b;
      var y = Object.getOwnPropertyNames(a).map(function(R) {
        return a[R];
      });
      if (y.join("") !== "0123456789")
        return !1;
      var P = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(R) {
        P[R] = R;
      }), Object.keys(Object.assign({}, P)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return se = s() ? Object.assign : function(l, a) {
    for (var b, y = r(l), P, R = 1; R < arguments.length; R++) {
      b = Object(arguments[R]);
      for (var j in b)
        e.call(b, j) && (y[j] = b[j]);
      if (n) {
        P = n(b);
        for (var q = 0; q < P.length; q++)
          t.call(b, P[q]) && (y[P[q]] = b[P[q]]);
      }
    }
    return y;
  }, se;
}
var ce, me;
function ye() {
  if (me) return ce;
  me = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ce = n, ce;
}
var le, Te;
function Ne() {
  return Te || (Te = 1, le = Function.call.bind(Object.prototype.hasOwnProperty)), le;
}
var fe, Oe;
function Ye() {
  if (Oe) return fe;
  Oe = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ ye(), t = {}, r = /* @__PURE__ */ Ne();
    n = function(l) {
      var a = "Warning: " + l;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function s(l, a, b, y, P) {
    if (process.env.NODE_ENV !== "production") {
      for (var R in l)
        if (r(l, R)) {
          var j;
          try {
            if (typeof l[R] != "function") {
              var q = Error(
                (y || "React class") + ": " + b + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw q.name = "Invariant Violation", q;
            }
            j = l[R](a, R, y, b, null, e);
          } catch (L) {
            j = L;
          }
          if (j && !(j instanceof Error) && n(
            (y || "React class") + ": type specification of " + b + " `" + R + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof j + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), j instanceof Error && !(j.message in t)) {
            t[j.message] = !0;
            var W = P ? P() : "";
            n(
              "Failed " + b + " type: " + j.message + (W ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, fe = s, fe;
}
var de, we;
function Ge() {
  if (we) return de;
  we = 1;
  var n = Ie, e = $e(), t = /* @__PURE__ */ ye(), r = /* @__PURE__ */ Ne(), s = /* @__PURE__ */ Ye(), l = function() {
  };
  process.env.NODE_ENV !== "production" && (l = function(b) {
    var y = "Warning: " + b;
    typeof console < "u" && console.error(y);
    try {
      throw new Error(y);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return de = function(b, y) {
    var P = typeof Symbol == "function" && Symbol.iterator, R = "@@iterator";
    function j(u) {
      var c = u && (P && u[P] || u[R]);
      if (typeof c == "function")
        return c;
    }
    var q = "<<anonymous>>", W = {
      array: M("array"),
      bigint: M("bigint"),
      bool: M("boolean"),
      func: M("function"),
      number: M("number"),
      object: M("object"),
      string: M("string"),
      symbol: M("symbol"),
      any: J(),
      arrayOf: Z,
      element: G(),
      elementType: Y(),
      instanceOf: h,
      node: N(),
      objectOf: S,
      oneOf: v,
      oneOfType: d,
      shape: T,
      exact: i
    };
    function L(u, c) {
      return u === c ? u !== 0 || 1 / u === 1 / c : u !== u && c !== c;
    }
    function f(u, c) {
      this.message = u, this.data = c && typeof c == "object" ? c : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function K(u) {
      if (process.env.NODE_ENV !== "production")
        var c = {}, O = 0;
      function E(C, k, D, I, x, _, $) {
        if (I = I || q, _ = _ || D, $ !== t) {
          if (y) {
            var U = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw U.name = "Invariant Violation", U;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var X = I + ":" + D;
            !c[X] && // Avoid spamming the console because they are often not actionable except for lib authors
            O < 3 && (l(
              "You are manually calling a React.PropTypes validation function for the `" + _ + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), c[X] = !0, O++);
          }
        }
        return k[D] == null ? C ? k[D] === null ? new f("The " + x + " `" + _ + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new f("The " + x + " `" + _ + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : u(k, D, I, x, _);
      }
      var g = E.bind(null, !1);
      return g.isRequired = E.bind(null, !0), g;
    }
    function M(u) {
      function c(O, E, g, C, k, D) {
        var I = O[E], x = m(I);
        if (x !== u) {
          var _ = w(I);
          return new f(
            "Invalid " + C + " `" + k + "` of type " + ("`" + _ + "` supplied to `" + g + "`, expected ") + ("`" + u + "`."),
            { expectedType: u }
          );
        }
        return null;
      }
      return K(c);
    }
    function J() {
      return K(a);
    }
    function Z(u) {
      function c(O, E, g, C, k) {
        if (typeof u != "function")
          return new f("Property `" + k + "` of component `" + g + "` has invalid PropType notation inside arrayOf.");
        var D = O[E];
        if (!Array.isArray(D)) {
          var I = m(D);
          return new f("Invalid " + C + " `" + k + "` of type " + ("`" + I + "` supplied to `" + g + "`, expected an array."));
        }
        for (var x = 0; x < D.length; x++) {
          var _ = u(D, x, g, C, k + "[" + x + "]", t);
          if (_ instanceof Error)
            return _;
        }
        return null;
      }
      return K(c);
    }
    function G() {
      function u(c, O, E, g, C) {
        var k = c[O];
        if (!b(k)) {
          var D = m(k);
          return new f("Invalid " + g + " `" + C + "` of type " + ("`" + D + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return K(u);
    }
    function Y() {
      function u(c, O, E, g, C) {
        var k = c[O];
        if (!n.isValidElementType(k)) {
          var D = m(k);
          return new f("Invalid " + g + " `" + C + "` of type " + ("`" + D + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return K(u);
    }
    function h(u) {
      function c(O, E, g, C, k) {
        if (!(O[E] instanceof u)) {
          var D = u.name || q, I = F(O[E]);
          return new f("Invalid " + C + " `" + k + "` of type " + ("`" + I + "` supplied to `" + g + "`, expected ") + ("instance of `" + D + "`."));
        }
        return null;
      }
      return K(c);
    }
    function v(u) {
      if (!Array.isArray(u))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? l(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : l("Invalid argument supplied to oneOf, expected an array.")), a;
      function c(O, E, g, C, k) {
        for (var D = O[E], I = 0; I < u.length; I++)
          if (L(D, u[I]))
            return null;
        var x = JSON.stringify(u, function($, U) {
          var X = w(U);
          return X === "symbol" ? String(U) : U;
        });
        return new f("Invalid " + C + " `" + k + "` of value `" + String(D) + "` " + ("supplied to `" + g + "`, expected one of " + x + "."));
      }
      return K(c);
    }
    function S(u) {
      function c(O, E, g, C, k) {
        if (typeof u != "function")
          return new f("Property `" + k + "` of component `" + g + "` has invalid PropType notation inside objectOf.");
        var D = O[E], I = m(D);
        if (I !== "object")
          return new f("Invalid " + C + " `" + k + "` of type " + ("`" + I + "` supplied to `" + g + "`, expected an object."));
        for (var x in D)
          if (r(D, x)) {
            var _ = u(D, x, g, C, k + "." + x, t);
            if (_ instanceof Error)
              return _;
          }
        return null;
      }
      return K(c);
    }
    function d(u) {
      if (!Array.isArray(u))
        return process.env.NODE_ENV !== "production" && l("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var c = 0; c < u.length; c++) {
        var O = u[c];
        if (typeof O != "function")
          return l(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + A(O) + " at index " + c + "."
          ), a;
      }
      function E(g, C, k, D, I) {
        for (var x = [], _ = 0; _ < u.length; _++) {
          var $ = u[_], U = $(g, C, k, D, I, t);
          if (U == null)
            return null;
          U.data && r(U.data, "expectedType") && x.push(U.data.expectedType);
        }
        var X = x.length > 0 ? ", expected one of type [" + x.join(", ") + "]" : "";
        return new f("Invalid " + D + " `" + I + "` supplied to " + ("`" + k + "`" + X + "."));
      }
      return K(E);
    }
    function N() {
      function u(c, O, E, g, C) {
        return o(c[O]) ? null : new f("Invalid " + g + " `" + C + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return K(u);
    }
    function B(u, c, O, E, g) {
      return new f(
        (u || "React class") + ": " + c + " type `" + O + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + g + "`."
      );
    }
    function T(u) {
      function c(O, E, g, C, k) {
        var D = O[E], I = m(D);
        if (I !== "object")
          return new f("Invalid " + C + " `" + k + "` of type `" + I + "` " + ("supplied to `" + g + "`, expected `object`."));
        for (var x in u) {
          var _ = u[x];
          if (typeof _ != "function")
            return B(g, C, k, x, w(_));
          var $ = _(D, x, g, C, k + "." + x, t);
          if ($)
            return $;
        }
        return null;
      }
      return K(c);
    }
    function i(u) {
      function c(O, E, g, C, k) {
        var D = O[E], I = m(D);
        if (I !== "object")
          return new f("Invalid " + C + " `" + k + "` of type `" + I + "` " + ("supplied to `" + g + "`, expected `object`."));
        var x = e({}, O[E], u);
        for (var _ in x) {
          var $ = u[_];
          if (r(u, _) && typeof $ != "function")
            return B(g, C, k, _, w($));
          if (!$)
            return new f(
              "Invalid " + C + " `" + k + "` key `" + _ + "` supplied to `" + g + "`.\nBad object: " + JSON.stringify(O[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(u), null, "  ")
            );
          var U = $(D, _, g, C, k + "." + _, t);
          if (U)
            return U;
        }
        return null;
      }
      return K(c);
    }
    function o(u) {
      switch (typeof u) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !u;
        case "object":
          if (Array.isArray(u))
            return u.every(o);
          if (u === null || b(u))
            return !0;
          var c = j(u);
          if (c) {
            var O = c.call(u), E;
            if (c !== u.entries) {
              for (; !(E = O.next()).done; )
                if (!o(E.value))
                  return !1;
            } else
              for (; !(E = O.next()).done; ) {
                var g = E.value;
                if (g && !o(g[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function p(u, c) {
      return u === "symbol" ? !0 : c ? c["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && c instanceof Symbol : !1;
    }
    function m(u) {
      var c = typeof u;
      return Array.isArray(u) ? "array" : u instanceof RegExp ? "object" : p(c, u) ? "symbol" : c;
    }
    function w(u) {
      if (typeof u > "u" || u === null)
        return "" + u;
      var c = m(u);
      if (c === "object") {
        if (u instanceof Date)
          return "date";
        if (u instanceof RegExp)
          return "regexp";
      }
      return c;
    }
    function A(u) {
      var c = w(u);
      switch (c) {
        case "array":
        case "object":
          return "an " + c;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + c;
        default:
          return c;
      }
    }
    function F(u) {
      return !u.constructor || !u.constructor.name ? q : u.constructor.name;
    }
    return W.checkPropTypes = s, W.resetWarningCache = s.resetWarningCache, W.PropTypes = W, W;
  }, de;
}
var ve, Ee;
function ze() {
  if (Ee) return ve;
  Ee = 1;
  var n = /* @__PURE__ */ ye();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, ve = function() {
    function r(a, b, y, P, R, j) {
      if (j !== n) {
        var q = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw q.name = "Invariant Violation", q;
      }
    }
    r.isRequired = r;
    function s() {
      return r;
    }
    var l = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: s,
      element: r,
      elementType: r,
      instanceOf: s,
      node: r,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return l.PropTypes = l, l;
  }, ve;
}
var Pe;
function Ve() {
  if (Pe) return te.exports;
  if (Pe = 1, process.env.NODE_ENV !== "production") {
    var n = Ie, e = !0;
    te.exports = /* @__PURE__ */ Ge()(n.isElement, e);
  } else
    te.exports = /* @__PURE__ */ ze()();
  return te.exports;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Ae = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], ae = /* @__PURE__ */ Ae.join(","), _e = typeof Element > "u", H = _e ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, ie = !_e && Element.prototype.getRootNode ? function(n) {
  var e;
  return n == null || (e = n.getRootNode) === null || e === void 0 ? void 0 : e.call(n);
} : function(n) {
  return n == null ? void 0 : n.ownerDocument;
}, oe = function n(e, t) {
  var r;
  t === void 0 && (t = !0);
  var s = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), l = s === "" || s === "true", a = l || t && e && n(e.parentNode);
  return a;
}, He = function(e) {
  var t, r = e == null || (t = e.getAttribute) === null || t === void 0 ? void 0 : t.call(e, "contenteditable");
  return r === "" || r === "true";
}, xe = function(e, t, r) {
  if (oe(e))
    return [];
  var s = Array.prototype.slice.apply(e.querySelectorAll(ae));
  return t && H.call(e, ae) && s.unshift(e), s = s.filter(r), s;
}, qe = function n(e, t, r) {
  for (var s = [], l = Array.from(e); l.length; ) {
    var a = l.shift();
    if (!oe(a, !1))
      if (a.tagName === "SLOT") {
        var b = a.assignedElements(), y = b.length ? b : a.children, P = n(y, !0, r);
        r.flatten ? s.push.apply(s, P) : s.push({
          scopeParent: a,
          candidates: P
        });
      } else {
        var R = H.call(a, ae);
        R && r.filter(a) && (t || !e.includes(a)) && s.push(a);
        var j = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), q = !oe(j, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (j && q) {
          var W = n(j === !0 ? a.children : j.children, !0, r);
          r.flatten ? s.push.apply(s, W) : s.push({
            scopeParent: a,
            candidates: W
          });
        } else
          l.unshift.apply(l, a.children);
      }
  }
  return s;
}, Be = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, z = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || He(e)) && !Be(e) ? 0 : e.tabIndex;
}, Je = function(e, t) {
  var r = z(e);
  return r < 0 && t && !Be(e) ? 0 : r;
}, Xe = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, Le = function(e) {
  return e.tagName === "INPUT";
}, Ze = function(e) {
  return Le(e) && e.type === "hidden";
}, Qe = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return t;
}, et = function(e, t) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === t)
      return e[r];
}, tt = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || ie(e), r = function(b) {
    return t.querySelectorAll('input[type="radio"][name="' + b + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(e.name));
  else
    try {
      s = r(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var l = et(s, e.form);
  return !l || l === e;
}, rt = function(e) {
  return Le(e) && e.type === "radio";
}, nt = function(e) {
  return rt(e) && !tt(e);
}, at = function(e) {
  var t, r = e && ie(e), s = (t = r) === null || t === void 0 ? void 0 : t.host, l = !1;
  if (r && r !== e) {
    var a, b, y;
    for (l = !!((a = s) !== null && a !== void 0 && (b = a.ownerDocument) !== null && b !== void 0 && b.contains(s) || e != null && (y = e.ownerDocument) !== null && y !== void 0 && y.contains(e)); !l && s; ) {
      var P, R, j;
      r = ie(s), s = (P = r) === null || P === void 0 ? void 0 : P.host, l = !!((R = s) !== null && R !== void 0 && (j = R.ownerDocument) !== null && j !== void 0 && j.contains(s));
    }
  }
  return l;
}, Fe = function(e) {
  var t = e.getBoundingClientRect(), r = t.width, s = t.height;
  return r === 0 && s === 0;
}, it = function(e, t) {
  var r = t.displayCheck, s = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var l = H.call(e, "details>summary:first-of-type"), a = l ? e.parentElement : e;
  if (H.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var b = e; e; ) {
        var y = e.parentElement, P = ie(e);
        if (y && !y.shadowRoot && s(y) === !0)
          return Fe(e);
        e.assignedSlot ? e = e.assignedSlot : !y && P !== e.ownerDocument ? e = P.host : e = y;
      }
      e = b;
    }
    if (at(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Fe(e);
  return !1;
}, ot = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var r = 0; r < t.children.length; r++) {
          var s = t.children.item(r);
          if (s.tagName === "LEGEND")
            return H.call(t, "fieldset[disabled] *") ? !0 : !s.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, ue = function(e, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  oe(t) || Ze(t) || it(t, e) || // For a details element with a summary, the summary element gets the focus
  Qe(t) || ot(t));
}, be = function(e, t) {
  return !(nt(t) || z(t) < 0 || !ue(e, t));
}, ut = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, st = function n(e) {
  var t = [], r = [];
  return e.forEach(function(s, l) {
    var a = !!s.scopeParent, b = a ? s.scopeParent : s, y = Je(b, a), P = a ? n(s.candidates) : b;
    y === 0 ? a ? t.push.apply(t, P) : t.push(b) : r.push({
      documentOrder: l,
      tabIndex: y,
      item: s,
      isScope: a,
      content: P
    });
  }), r.sort(Xe).reduce(function(s, l) {
    return l.isScope ? s.push.apply(s, l.content) : s.push(l.content), s;
  }, []).concat(t);
}, Ke = function(e, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = qe([e], t.includeContainer, {
    filter: be.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: ut
  }) : r = xe(e, t.includeContainer, be.bind(null, t)), st(r);
}, We = function(e, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = qe([e], t.includeContainer, {
    filter: ue.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : r = xe(e, t.includeContainer, ue.bind(null, t)), r;
}, V = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return H.call(e, ae) === !1 ? !1 : be(t, e);
}, ct = /* @__PURE__ */ Ae.concat("iframe").join(","), ne = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return H.call(e, ct) === !1 ? !1 : ue(t, e);
};
const lt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable: We,
  getTabIndex: z,
  isFocusable: ne,
  isTabbable: V,
  tabbable: Ke
}, Symbol.toStringTag, { value: "Module" }));
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function he(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function ft(n) {
  if (Array.isArray(n)) return he(n);
}
function dt(n, e, t) {
  return (e = yt(e)) in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function vt(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function pt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ke(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function De(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ke(Object(t), !0).forEach(function(r) {
      dt(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ke(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function bt(n) {
  return ft(n) || vt(n) || gt(n) || pt();
}
function ht(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function yt(n) {
  var e = ht(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
function gt(n, e) {
  if (n) {
    if (typeof n == "string") return he(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? he(n, e) : void 0;
  }
}
var Re = {
  activateTrap: function(e, t) {
    if (e.length > 0) {
      var r = e[e.length - 1];
      r !== t && r._setPausedState(!0);
    }
    var s = e.indexOf(t);
    s === -1 || e.splice(s, 1), e.push(t);
  },
  deactivateTrap: function(e, t) {
    var r = e.indexOf(t);
    r !== -1 && e.splice(r, 1), e.length > 0 && !e[e.length - 1]._isManuallyPaused() && e[e.length - 1]._setPausedState(!1);
  }
}, mt = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Tt = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, ee = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, Ot = function(e) {
  return ee(e) && !e.shiftKey;
}, wt = function(e) {
  return ee(e) && e.shiftKey;
}, Se = function(e) {
  return setTimeout(e, 0);
}, Q = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
    r[s - 1] = arguments[s];
  return typeof e == "function" ? e.apply(void 0, r) : e;
}, re = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, Et = [], Pt = function(e, t) {
  var r = (t == null ? void 0 : t.document) || document, s = (t == null ? void 0 : t.trapStack) || Et, l = De({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Ot,
    isKeyBackward: wt
  }, t), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, b, y = function(i, o, p) {
    return i && i[o] !== void 0 ? i[o] : l[p || o];
  }, P = function(i, o) {
    var p = typeof (o == null ? void 0 : o.composedPath) == "function" ? o.composedPath() : void 0;
    return a.containerGroups.findIndex(function(m) {
      var w = m.container, A = m.tabbableNodes;
      return w.contains(i) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (p == null ? void 0 : p.includes(w)) || A.find(function(F) {
        return F === i;
      });
    });
  }, R = function(i) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = o.hasFallback, m = p === void 0 ? !1 : p, w = o.params, A = w === void 0 ? [] : w, F = l[i];
    if (typeof F == "function" && (F = F.apply(void 0, bt(A))), F === !0 && (F = void 0), !F) {
      if (F === void 0 || F === !1)
        return F;
      throw new Error("`".concat(i, "` was specified but was not a node, or did not return a node"));
    }
    var u = F;
    if (typeof F == "string") {
      try {
        u = r.querySelector(F);
      } catch (c) {
        throw new Error("`".concat(i, '` appears to be an invalid selector; error="').concat(c.message, '"'));
      }
      if (!u && !m)
        throw new Error("`".concat(i, "` as selector refers to no known node"));
    }
    return u;
  }, j = function() {
    var i = R("initialFocus", {
      hasFallback: !0
    });
    if (i === !1)
      return !1;
    if (i === void 0 || i && !ne(i, l.tabbableOptions))
      if (P(r.activeElement) >= 0)
        i = r.activeElement;
      else {
        var o = a.tabbableGroups[0], p = o && o.firstTabbableNode;
        i = p || R("fallbackFocus");
      }
    else i === null && (i = R("fallbackFocus"));
    if (!i)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return i;
  }, q = function() {
    if (a.containerGroups = a.containers.map(function(i) {
      var o = Ke(i, l.tabbableOptions), p = We(i, l.tabbableOptions), m = o.length > 0 ? o[0] : void 0, w = o.length > 0 ? o[o.length - 1] : void 0, A = p.find(function(c) {
        return V(c);
      }), F = p.slice().reverse().find(function(c) {
        return V(c);
      }), u = !!o.find(function(c) {
        return z(c) > 0;
      });
      return {
        container: i,
        tabbableNodes: o,
        focusableNodes: p,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: u,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: m,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: w,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: A,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: F,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(O) {
          var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, g = o.indexOf(O);
          return g < 0 ? E ? p.slice(p.indexOf(O) + 1).find(function(C) {
            return V(C);
          }) : p.slice(0, p.indexOf(O)).reverse().find(function(C) {
            return V(C);
          }) : o[g + (E ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(i) {
      return i.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !R("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(i) {
      return i.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, W = function(i) {
    var o = i.activeElement;
    if (o)
      return o.shadowRoot && o.shadowRoot.activeElement !== null ? W(o.shadowRoot) : o;
  }, L = function(i) {
    if (i !== !1 && i !== W(document)) {
      if (!i || !i.focus) {
        L(j());
        return;
      }
      i.focus({
        preventScroll: !!l.preventScroll
      }), a.mostRecentlyFocusedNode = i, mt(i) && i.select();
    }
  }, f = function(i) {
    var o = R("setReturnFocus", {
      params: [i]
    });
    return o || (o === !1 ? !1 : i);
  }, K = function(i) {
    var o = i.target, p = i.event, m = i.isBackward, w = m === void 0 ? !1 : m;
    o = o || re(p), q();
    var A = null;
    if (a.tabbableGroups.length > 0) {
      var F = P(o, p), u = F >= 0 ? a.containerGroups[F] : void 0;
      if (F < 0)
        w ? A = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : A = a.tabbableGroups[0].firstTabbableNode;
      else if (w) {
        var c = a.tabbableGroups.findIndex(function(D) {
          var I = D.firstTabbableNode;
          return o === I;
        });
        if (c < 0 && (u.container === o || ne(o, l.tabbableOptions) && !V(o, l.tabbableOptions) && !u.nextTabbableNode(o, !1)) && (c = F), c >= 0) {
          var O = c === 0 ? a.tabbableGroups.length - 1 : c - 1, E = a.tabbableGroups[O];
          A = z(o) >= 0 ? E.lastTabbableNode : E.lastDomTabbableNode;
        } else ee(p) || (A = u.nextTabbableNode(o, !1));
      } else {
        var g = a.tabbableGroups.findIndex(function(D) {
          var I = D.lastTabbableNode;
          return o === I;
        });
        if (g < 0 && (u.container === o || ne(o, l.tabbableOptions) && !V(o, l.tabbableOptions) && !u.nextTabbableNode(o)) && (g = F), g >= 0) {
          var C = g === a.tabbableGroups.length - 1 ? 0 : g + 1, k = a.tabbableGroups[C];
          A = z(o) >= 0 ? k.firstTabbableNode : k.firstDomTabbableNode;
        } else ee(p) || (A = u.nextTabbableNode(o));
      }
    } else
      A = R("fallbackFocus");
    return A;
  }, M = function(i) {
    var o = re(i);
    if (!(P(o, i) >= 0)) {
      if (Q(l.clickOutsideDeactivates, i)) {
        b.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: l.returnFocusOnDeactivate
        });
        return;
      }
      Q(l.allowOutsideClick, i) || i.preventDefault();
    }
  }, J = function(i) {
    var o = re(i), p = P(o, i) >= 0;
    if (p || o instanceof Document)
      p && (a.mostRecentlyFocusedNode = o);
    else {
      i.stopImmediatePropagation();
      var m, w = !0;
      if (a.mostRecentlyFocusedNode)
        if (z(a.mostRecentlyFocusedNode) > 0) {
          var A = P(a.mostRecentlyFocusedNode), F = a.containerGroups[A].tabbableNodes;
          if (F.length > 0) {
            var u = F.findIndex(function(c) {
              return c === a.mostRecentlyFocusedNode;
            });
            u >= 0 && (l.isKeyForward(a.recentNavEvent) ? u + 1 < F.length && (m = F[u + 1], w = !1) : u - 1 >= 0 && (m = F[u - 1], w = !1));
          }
        } else
          a.containerGroups.some(function(c) {
            return c.tabbableNodes.some(function(O) {
              return z(O) > 0;
            });
          }) || (w = !1);
      else
        w = !1;
      w && (m = K({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: l.isKeyBackward(a.recentNavEvent)
      })), L(m || a.mostRecentlyFocusedNode || j());
    }
    a.recentNavEvent = void 0;
  }, Z = function(i) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = i;
    var p = K({
      event: i,
      isBackward: o
    });
    p && (ee(i) && i.preventDefault(), L(p));
  }, G = function(i) {
    (l.isKeyForward(i) || l.isKeyBackward(i)) && Z(i, l.isKeyBackward(i));
  }, Y = function(i) {
    Tt(i) && Q(l.escapeDeactivates, i) !== !1 && (i.preventDefault(), b.deactivate());
  }, h = function(i) {
    var o = re(i);
    P(o, i) >= 0 || Q(l.clickOutsideDeactivates, i) || Q(l.allowOutsideClick, i) || (i.preventDefault(), i.stopImmediatePropagation());
  }, v = function() {
    if (a.active)
      return Re.activateTrap(s, b), a.delayInitialFocusTimer = l.delayInitialFocus ? Se(function() {
        L(j());
      }) : L(j()), r.addEventListener("focusin", J, !0), r.addEventListener("mousedown", M, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", M, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", h, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", G, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", Y), b;
  }, S = function() {
    if (a.active)
      return r.removeEventListener("focusin", J, !0), r.removeEventListener("mousedown", M, !0), r.removeEventListener("touchstart", M, !0), r.removeEventListener("click", h, !0), r.removeEventListener("keydown", G, !0), r.removeEventListener("keydown", Y), b;
  }, d = function(i) {
    var o = i.some(function(p) {
      var m = Array.from(p.removedNodes);
      return m.some(function(w) {
        return w === a.mostRecentlyFocusedNode;
      });
    });
    o && L(j());
  }, N = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(d) : void 0, B = function() {
    N && (N.disconnect(), a.active && !a.paused && a.containers.map(function(i) {
      N.observe(i, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return b = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(i) {
      if (a.active)
        return this;
      var o = y(i, "onActivate"), p = y(i, "onPostActivate"), m = y(i, "checkCanFocusTrap");
      m || q(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = r.activeElement, o == null || o();
      var w = function() {
        m && q(), v(), B(), p == null || p();
      };
      return m ? (m(a.containers.concat()).then(w, w), this) : (w(), this);
    },
    deactivate: function(i) {
      if (!a.active)
        return this;
      var o = De({
        onDeactivate: l.onDeactivate,
        onPostDeactivate: l.onPostDeactivate,
        checkCanReturnFocus: l.checkCanReturnFocus
      }, i);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, S(), a.active = !1, a.paused = !1, B(), Re.deactivateTrap(s, b);
      var p = y(o, "onDeactivate"), m = y(o, "onPostDeactivate"), w = y(o, "checkCanReturnFocus"), A = y(o, "returnFocus", "returnFocusOnDeactivate");
      p == null || p();
      var F = function() {
        Se(function() {
          A && L(f(a.nodeFocusedBeforeActivation)), m == null || m();
        });
      };
      return A && w ? (w(f(a.nodeFocusedBeforeActivation)).then(F, F), this) : (F(), this);
    },
    pause: function(i) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, i)) : this;
    },
    unpause: function(i) {
      return a.active ? (a.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, i)) : this;
    },
    updateContainerElements: function(i) {
      var o = [].concat(i).filter(Boolean);
      return a.containers = o.map(function(p) {
        return typeof p == "string" ? r.querySelector(p) : p;
      }), a.active && q(), B(), this;
    }
  }, Object.defineProperties(b, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(i, o) {
        if (a.paused === i)
          return this;
        if (a.paused = i, i) {
          var p = y(o, "onPause"), m = y(o, "onPostPause");
          p == null || p(), S(), B(), m == null || m();
        } else {
          var w = y(o, "onUnpause"), A = y(o, "onPostUnpause");
          w == null || w(), q(), v(), B(), A == null || A();
        }
        return this;
      }
    }
  }), b.updateContainerElements(e), b;
};
const Ft = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: Pt
}, Symbol.toStringTag, { value: "Module" })), kt = /* @__PURE__ */ je(Ft), Dt = /* @__PURE__ */ je(lt);
var pe, Ce;
function Rt() {
  if (Ce) return pe;
  Ce = 1;
  function n(h) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
      return typeof v;
    } : function(v) {
      return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
    }, n(h);
  }
  function e(h, v) {
    if (!(h instanceof v)) throw new TypeError("Cannot call a class as a function");
  }
  function t(h, v) {
    for (var S = 0; S < v.length; S++) {
      var d = v[S];
      d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(h, q(d.key), d);
    }
  }
  function r(h, v, S) {
    return v && t(h.prototype, v), Object.defineProperty(h, "prototype", { writable: !1 }), h;
  }
  function s(h, v, S) {
    return v = y(v), l(h, b() ? Reflect.construct(v, S || [], y(h).constructor) : v.apply(h, S));
  }
  function l(h, v) {
    if (v && (n(v) == "object" || typeof v == "function")) return v;
    if (v !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return a(h);
  }
  function a(h) {
    if (h === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return h;
  }
  function b() {
    try {
      var h = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (b = function() {
      return !!h;
    })();
  }
  function y(h) {
    return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(v) {
      return v.__proto__ || Object.getPrototypeOf(v);
    }, y(h);
  }
  function P(h, v) {
    if (typeof v != "function" && v !== null) throw new TypeError("Super expression must either be null or a function");
    h.prototype = Object.create(v && v.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), Object.defineProperty(h, "prototype", { writable: !1 }), v && R(h, v);
  }
  function R(h, v) {
    return R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(S, d) {
      return S.__proto__ = d, S;
    }, R(h, v);
  }
  function j(h, v, S) {
    return (v = q(v)) in h ? Object.defineProperty(h, v, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : h[v] = S, h;
  }
  function q(h) {
    var v = W(h, "string");
    return n(v) == "symbol" ? v : v + "";
  }
  function W(h, v) {
    if (n(h) != "object" || !h) return h;
    var S = h[Symbol.toPrimitive];
    if (S !== void 0) {
      var d = S.call(h, v);
      if (n(d) != "object") return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (v === "string" ? String : Number)(h);
  }
  var L = Ue, f = /* @__PURE__ */ Ve(), K = kt, M = K.createFocusTrap, J = Dt, Z = J.isFocusable, G = /* @__PURE__ */ function(h) {
    function v(S) {
      var d;
      e(this, v), d = s(this, v, [S]), j(d, "getNodeForOption", function(T) {
        var i, o = (i = this.internalOptions[T]) !== null && i !== void 0 ? i : this.originalOptions[T];
        if (typeof o == "function") {
          for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), w = 1; w < p; w++)
            m[w - 1] = arguments[w];
          o = o.apply(void 0, m);
        }
        if (o === !0 && (o = void 0), !o) {
          if (o === void 0 || o === !1)
            return o;
          throw new Error("`".concat(T, "` was specified but was not a node, or did not return a node"));
        }
        var A = o;
        if (typeof o == "string") {
          var F;
          if (A = (F = this.getDocument()) === null || F === void 0 ? void 0 : F.querySelector(o), !A)
            throw new Error("`".concat(T, "` as selector refers to no known node"));
        }
        return A;
      }), d.handleDeactivate = d.handleDeactivate.bind(d), d.handlePostDeactivate = d.handlePostDeactivate.bind(d), d.handleClickOutsideDeactivates = d.handleClickOutsideDeactivates.bind(d), d.internalOptions = {
        // We need to hijack the returnFocusOnDeactivate option,
        // because React can move focus into the element before we arrived at
        // this lifecycle hook (e.g. with autoFocus inputs). So the component
        // captures the previouslyFocusedElement in componentWillMount,
        // then (optionally) returns focus to it in componentWillUnmount.
        returnFocusOnDeactivate: !1,
        // the rest of these are also related to deactivation of the trap, and we
        //  need to use them and control them as well
        checkCanReturnFocus: null,
        onDeactivate: d.handleDeactivate,
        onPostDeactivate: d.handlePostDeactivate,
        // we need to special-case this setting as well so that we can know if we should
        //  NOT return focus if the trap gets auto-deactivated as the result of an
        //  outside click (otherwise, we'll always think we should return focus because
        //  of how we manage that flag internally here)
        clickOutsideDeactivates: d.handleClickOutsideDeactivates
      }, d.originalOptions = {
        // because of the above `internalOptions`, we maintain our own flag for
        //  this option, and default it to `true` because that's focus-trap's default
        returnFocusOnDeactivate: !0,
        // because of the above `internalOptions`, we keep these separate since
        //  they're part of the deactivation process which we configure (internally) to
        //  be shared between focus-trap and focus-trap-react
        onDeactivate: null,
        onPostDeactivate: null,
        checkCanReturnFocus: null,
        // the user's setting, defaulted to false since focus-trap defaults this to false
        clickOutsideDeactivates: !1
      };
      var N = S.focusTrapOptions;
      for (var B in N)
        if (Object.prototype.hasOwnProperty.call(N, B)) {
          if (B === "returnFocusOnDeactivate" || B === "onDeactivate" || B === "onPostDeactivate" || B === "checkCanReturnFocus" || B === "clickOutsideDeactivates") {
            d.originalOptions[B] = N[B];
            continue;
          }
          d.internalOptions[B] = N[B];
        }
      return d.outsideClick = null, d.focusTrapElements = S.containerElements || [], d.updatePreviousElement(), d;
    }
    return P(v, h), r(v, [{
      key: "getDocument",
      value: function() {
        return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
      }
    }, {
      key: "getReturnFocusNode",
      value: function() {
        var d = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
        return d || (d === !1 ? !1 : this.previouslyFocusedElement);
      }
      /** Update the previously focused element with the currently focused element. */
    }, {
      key: "updatePreviousElement",
      value: function() {
        var d = this.getDocument();
        d && (this.previouslyFocusedElement = d.activeElement);
      }
    }, {
      key: "deactivateTrap",
      value: function() {
        !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
          // NOTE: we never let the trap return the focus since we do that ourselves
          returnFocus: !1,
          // we'll call this in our own post deactivate handler so make sure the trap doesn't
          //  do it prematurely
          checkCanReturnFocus: null,
          // let it call the user's original deactivate handler, if any, instead of
          //  our own which calls back into this function
          onDeactivate: this.originalOptions.onDeactivate
          // NOTE: for post deactivate, don't specify anything so that it calls the
          //  onPostDeactivate handler specified on `this.internalOptions`
          //  which will always be our own `handlePostDeactivate()` handler, which
          //  will finish things off by calling the user's provided onPostDeactivate
          //  handler, if any, at the right time
          // onPostDeactivate: NOTHING
        });
      }
    }, {
      key: "handleClickOutsideDeactivates",
      value: function(d) {
        var N = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, d) : this.originalOptions.clickOutsideDeactivates;
        return N && (this.outsideClick = {
          target: d.target,
          allowDeactivation: N
        }), N;
      }
    }, {
      key: "handleDeactivate",
      value: function() {
        this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
      }
    }, {
      key: "handlePostDeactivate",
      value: function() {
        var d = this, N = function() {
          var T = d.getReturnFocusNode(), i = !!// did the consumer allow it?
          (d.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
          T !== null && T !== void 0 && T.focus && // was there an outside click that allowed deactivation?
          (!d.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
          d.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
          //  as a result of the click-through) -- in which case do NOT restore focus
          //  to `returnFocusNode` because focus should remain on the outside node
          !Z(d.outsideClick.target, d.internalOptions.tabbableOptions))), o = d.internalOptions.preventScroll, p = o === void 0 ? !1 : o;
          i && T.focus({
            preventScroll: p
          }), d.originalOptions.onPostDeactivate && d.originalOptions.onPostDeactivate.call(null), d.outsideClick = null;
        };
        this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(N, N) : N();
      }
    }, {
      key: "setupFocusTrap",
      value: function() {
        if (this.focusTrap)
          this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
        else {
          var d = this.focusTrapElements.some(Boolean);
          d && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
        }
      }
    }, {
      key: "componentDidMount",
      value: function() {
        this.props.active && this.setupFocusTrap();
      }
    }, {
      key: "componentDidUpdate",
      value: function(d) {
        if (this.focusTrap) {
          d.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
          var N = !d.active && this.props.active, B = d.active && !this.props.active, T = !d.paused && this.props.paused, i = d.paused && !this.props.paused;
          if (N && (this.updatePreviousElement(), this.focusTrap.activate()), B) {
            this.deactivateTrap();
            return;
          }
          T && this.focusTrap.pause(), i && this.focusTrap.unpause();
        } else
          d.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.deactivateTrap();
      }
    }, {
      key: "render",
      value: function() {
        var d = this, N = this.props.children ? L.Children.only(this.props.children) : void 0;
        if (N) {
          if (N.type && N.type === L.Fragment)
            throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
          var B = function(o) {
            var p = d.props.containerElements;
            N && (typeof N.ref == "function" ? N.ref(o) : N.ref && (N.ref.current = o)), d.focusTrapElements = p || [o];
          }, T = L.cloneElement(N, {
            ref: B
          });
          return T;
        }
        return null;
      }
    }]);
  }(L.Component), Y = typeof Element > "u" ? Function : Element;
  return G.propTypes = {
    active: f.bool,
    paused: f.bool,
    focusTrapOptions: f.shape({
      document: f.object,
      onActivate: f.func,
      onPostActivate: f.func,
      checkCanFocusTrap: f.func,
      onPause: f.func,
      onPostPause: f.func,
      onUnpause: f.func,
      onPostUnpause: f.func,
      onDeactivate: f.func,
      onPostDeactivate: f.func,
      checkCanReturnFocus: f.func,
      initialFocus: f.oneOfType([f.instanceOf(Y), f.string, f.bool, f.func]),
      fallbackFocus: f.oneOfType([
        f.instanceOf(Y),
        f.string,
        // NOTE: does not support `false` as value (or return value from function)
        f.func
      ]),
      escapeDeactivates: f.oneOfType([f.bool, f.func]),
      clickOutsideDeactivates: f.oneOfType([f.bool, f.func]),
      returnFocusOnDeactivate: f.bool,
      setReturnFocus: f.oneOfType([f.instanceOf(Y), f.string, f.bool, f.func]),
      allowOutsideClick: f.oneOfType([f.bool, f.func]),
      preventScroll: f.bool,
      tabbableOptions: f.shape({
        displayCheck: f.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
        getShadowRoot: f.oneOfType([f.bool, f.func])
      }),
      trapStack: f.array,
      isKeyForward: f.func,
      isKeyBackward: f.func
    }),
    containerElements: f.arrayOf(f.instanceOf(Y)),
    // DOM element ONLY
    children: f.oneOfType([
      f.element,
      // React element
      f.instanceOf(Y)
      // DOM element
    ])
    // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
    //  specify it here. It's expected to be set to the function returned from
    //  require('focus-trap'), or one with a compatible interface.
  }, G.defaultProps = {
    active: !0,
    paused: !1,
    focusTrapOptions: {},
    _createFocusTrap: M
  }, pe = G, pe;
}
var St = Rt();
const Nt = /* @__PURE__ */ Me(St);
export {
  Nt as F
};
